import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { Avatar } from "@fluentui/react-components";
import {
  renderTooltipHeader,
  createColumnMenu,
} from "../../../dashboard-util/dashboard-telerik-helper/dashboard-telerik-helper";
import { FluentBadge } from "../../../../../components/FluentUI/Fluent-Badge";
import { NameAndNoDealsBadge } from "../../../dashboard-util/dashboard-utils";

const EnergyAnalystSummaryGrid = ({ summaryItem = {} }) => {
  const [summaryState, setSummaryState] = useState({ sort: [], filter: null });
  const gridData = useMemo(() => {
  if (!summaryItem?.Analyst) return [];
  return [
    {
      ...summaryItem,
      UserName: summaryItem.Analyst.FullName,
    },
  ];
}, [summaryItem]);

  const isAccordionDisabled = true; //Logic for accordion is developed- but disabling it as per product's request
  const columnMenu = createColumnMenu(gridData);

  if (!summaryItem?.Analyst) {
    return null;
  }

  return (
    <div className="summary-grid-wrapper">
      <Grid
        data={gridData}
        sort={summaryState.sort}
        filter={summaryState.filter}
        onSortChange={(e) => setSummaryState({ ...summaryState, sort: e.sort })}
        onFilterChange={(e) =>
          setSummaryState({ ...summaryState, filter: e.filter })
        }
        className="energy-banker-time-log-summary-grid"
        resizable={true}
      >
        <Column
          field="Analyst.FullName"
          title={renderTooltipHeader(`${summaryItem?.Analyst?.Role?.includes("Analyst") ? "Analyst" : "Associate"}`)}
          columnMenu={columnMenu}
          cell={(props) => {
            return (
              <td className="summary-cell k-table-td avatar-cell">
                <div className="dashboard-username">
                  <Avatar name={summaryItem.Analyst.FullName} color="brand" size={32} />
                  <NameAndNoDealsBadge name={summaryItem.Analyst.FullName ?? '—'} />
                </div>
              </td>
            );
          }}
        />
        <Column
          field="TotalHoursLastWeek"
          title={renderTooltipHeader("Total (Actual) Hrs Spent Last Week")}
          columnMenu={columnMenu}
          cell={(props) => (
            <td className="summary-cell k-table-td" >
              {props.dataItem?.TotalHoursLastWeek ?? "—"}
            </td>
          )}
        />
        <Column
          field="TotalHoursLiveDeals"
          title={renderTooltipHeader("Total (Actual) Hrs Spent on Live Deals")}
          columnMenu={columnMenu}
          cell={(props) => (
            <td className="summary-cell k-table-td" >
              {props.dataItem?.TotalHoursLiveDeals ?? 0}&nbsp;
              <FluentBadge
                appearance="tint"
                shape="rounded"
                size="large"
                color="informative"
                text={`${props.dataItem?.PercentageTotalHoursLiveDeals ?? 0}%`}
              />
            </td>
          )}
        />
        <Column
          field="TotalHoursNonLiveDeals"
          title={renderTooltipHeader("Total (Actual) Hrs Spent on Non-Live Deals")}
          columnMenu={columnMenu}
          cell={(props) => (
            <td className="summary-cell k-table-td" >
              {props.dataItem?.TotalHoursNonLiveDeals ?? 0}&nbsp;
              <FluentBadge
                appearance="tint"
                shape="rounded"
                size="large"
                color="informative"
                text={`${props.dataItem?.PercentageTotalHoursNonLiveDeals ?? 0}%`}
              />
            </td>
          )}
        />
      </Grid>
    </div>
  );
};

EnergyAnalystSummaryGrid.propTypes = {
  summaryItem: PropTypes.shape({
    Staffer: PropTypes.shape({
      UserId: PropTypes.number,
      FullName: PropTypes.string
    }),
    Analyst: PropTypes.shape({
      UserId: PropTypes.number,
      FullName: PropTypes.string
    }),
    TotalHoursLastWeek: PropTypes.number,
    TotalHoursNextWeek: PropTypes.number,
    TotalPriorWeekEstimate: PropTypes.number,
    TotalWeekendHoursLastWeek: PropTypes.number,
    TotalHoursLiveDeals: PropTypes.number,
    TotalHoursNonLiveDeals: PropTypes.number,
    PercentageTotalHoursLiveDeals: PropTypes.number,
    PercentageTotalHoursNonLiveDeals: PropTypes.number,
    Projects: PropTypes.array
  }).isRequired
};

export default EnergyAnalystSummaryGrid;
